module.exports = __webpack_public_path__ + "img/Recognition@2x.aec277e2.png";